export default __webpack_public_path__ + "static/media/Mark-5-Suit-05.f1f9405e.jpg";